import type { ImgHTMLAttributes } from "react";

// mobile
import Dashboard from "../../assets/images/icon_exitpermit/dashboard.svg";
import In from "../../assets/images/icon_exitpermit/in.svg";
import Out from "../../assets/images/icon_exitpermit/out.svg";

type IconProps = ImgHTMLAttributes<HTMLImageElement>;

const createIcon = (src: string, alt: string) => (props: IconProps) => (
  <img src={src} alt={alt} loading="lazy" {...props} />
);

// mobile
export const DashboardIcon = createIcon(Dashboard, "Dashboard");
export const InIcon = createIcon(In, "In");
export const OutIcon = createIcon(Out, "Out");
